
import { Button } from "@/components/ui/button";
import { SignUpForm } from "./SignUpForm";
import { SignInForm } from "./SignInForm";
import { SocialAuth } from "./SocialAuth";
import { useTranslation } from "@/hooks/useTranslation";
import { Capacitor } from '@capacitor/core';

interface AuthFormProps {
  isSignUp: boolean;
  onToggleMode: () => void;
  onForgotPassword: () => void;
}

export function AuthForm({ isSignUp, onToggleMode, onForgotPassword }: AuthFormProps) {
  const { t } = useTranslation();
  const isNative = Capacitor.isNativePlatform();
  
  return (
    <div className="space-y-4">
      {isSignUp ? (
        <>
          <SocialAuth />
          {/* Only show divider when not on native platforms */}
          {!isNative && (
            <div className="relative my-4">
              <div className="absolute inset-0 flex items-center">
                <span className="w-full border-t" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-background px-2 text-muted-foreground">
                  {t('or_with_email')}
                </span>
              </div>
            </div>
          )}
          <SignUpForm onSuccess={onToggleMode} />
        </>
      ) : (
        <>
          <SignInForm onForgotPassword={onForgotPassword} />
          <SocialAuth />
        </>
      )}

      <Button
        type="button"
        variant="link"
        className="w-full mt-2"
        onClick={onToggleMode}
      >
        {isSignUp ? t('already_have_account') : t('dont_have_account')}
      </Button>
    </div>
  );
}
